import { defineModuleEvidenceContract } from './moduleEvidenceContract';
import { SGA_SPEND_SCHEMA_VERSIONS } from './schemaVersions';
import { SGA_SPEND_MODULE_EVIDENCE_CONTRACT } from './sgaSpendModuleEvidenceContract';

// outside-contractors is a standalone decision module (apps/api/src/decision-modules/
// outside-contractors), but its evidence identity is byte-identical to the sga-spend
// lever of the same name: evidenceKey 'approved_outside_contractors_snapshot',
// contextKind 'decision_agent:outside_contractors:governed_snapshot', schemaVersion
// 'outside_contractors_governed_snapshot_v1' (outside-contractors.data-lake-source.ts
// OUTSIDE_CONTRACTORS_DATA_LAKE_CONTEXT_KIND / _SCHEMA_VERSION). Same alias pattern as
// tech-software/professional-fees/shared-services/real-estate-footprint. Confirmed live
// on tenant helix_retail 2026-08-06: 3 APPROVED connector-derived rows (latest
// approvedAt 2026-07-29), plus older manual-admin and modeled rows under the same
// contextKind/schemaVersion.
const outsideContractorsEvidenceEntry =
  SGA_SPEND_MODULE_EVIDENCE_CONTRACT.entries.outside_contractors;

export const OUTSIDE_CONTRACTORS_STATE_KEYS = {
  governedSnapshot: outsideContractorsEvidenceEntry.stateKey,
  spendAttested: 'outside_contractors_spend_attested',
  spendGoverned: 'outside_contractors_spend_governed',
  addressableAttested: 'outside_contractors_addressable_attested',
  addressableGoverned: 'outside_contractors_addressable_governed',
  programAttested: 'outside_contractors_program_attested',
  programGoverned: 'outside_contractors_program_governed',
  spendSnapshot: 'outside-contractors-spend-snapshot',
  addressableSnapshot: 'outside-contractors-addressable-snapshot',
  programSnapshot: 'outside-contractors-program-snapshot',
} as const;

export const OUTSIDE_CONTRACTORS_EVIDENCE_KEYS = {
  governedSnapshot: outsideContractorsEvidenceEntry.evidenceKey,
  spendSnapshot: OUTSIDE_CONTRACTORS_STATE_KEYS.spendSnapshot,
  addressableSnapshot: OUTSIDE_CONTRACTORS_STATE_KEYS.addressableSnapshot,
  programSnapshot: OUTSIDE_CONTRACTORS_STATE_KEYS.programSnapshot,
} as const;

export const OUTSIDE_CONTRACTORS_BINDING_PLACEHOLDERS = {
  opportunityUsd: outsideContractorsEvidenceEntry.bindingPlaceholders[0],
} as const;

export const OUTSIDE_CONTRACTORS_SCHEMA_VERSIONS = {
  manifest: SGA_SPEND_SCHEMA_VERSIONS.manifest,
  governedSnapshot: outsideContractorsEvidenceEntry.schemaVersion,
} as const;

export const OUTSIDE_CONTRACTORS_MODULE_EVIDENCE_CONTRACT = defineModuleEvidenceContract(
  'outside-contractors',
  {
    governed_snapshot: outsideContractorsEvidenceEntry,
  },
  {
    evidenceKeys: Object.values(OUTSIDE_CONTRACTORS_EVIDENCE_KEYS),
    sourceClasses: [outsideContractorsEvidenceEntry.sourceClass],
    contextKinds: [outsideContractorsEvidenceEntry.contextKind],
    schemaVersions: Object.values(OUTSIDE_CONTRACTORS_SCHEMA_VERSIONS),
    stateKeys: Object.values(OUTSIDE_CONTRACTORS_STATE_KEYS),
    bindingPlaceholders: Object.values(OUTSIDE_CONTRACTORS_BINDING_PLACEHOLDERS),
  },
);

export type OutsideContractorsModuleEvidenceContract =
  typeof OUTSIDE_CONTRACTORS_MODULE_EVIDENCE_CONTRACT;
